// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { postJoinOrganization } from '../../apis/member';
import { postJoinOrganizationActions } from '../actionCreators/postJoinOrganizationActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: postJoinOrganizationActions.success,
  failure: postJoinOrganizationActions.failure
};

type RequestActionTypes = ActionType<
  typeof postJoinOrganizationActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const postJoinOrganizationEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(postJoinOrganizationActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { invitation } = action.payload;
      // send api promise
      return postJoinOrganization(invitation)
        .then(() => {
          // handle success case here
          return postJoinOrganizationActions.success({});
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return postJoinOrganizationActions.failure({ error });
        });
    })
  );
};
